<script setup>
const props = defineProps({
  articleData: {
        type: Object,
        default: () => {}
  },
})
</script>
<template>
    <div class="flex items-center">
      <IconAttachment :stroke="'#13A897'" />
        <div class="flex flex-wrap items-center gap-x-1">
          <span class="font-extralight whitespace-nowrap">
            {{ props.articleData.attachment_description }}
          </span>
            <NuxtLink
                class="text-celadon font-normal leading-tight inline-flex"
                :to="props.articleData.attachment"
            >
                Pobierz plik
            </NuxtLink>
        </div>
    </div>
</template>
